<template>
  <transition name="modal-fade">
    <v-dialog :value="active" width="80vh" persistent>
      <v-card class="logWrap">
        <v-card-title primary-title class="logWrap">
          <h3>Datos personales</h3>
        </v-card-title>
        <v-card-text class="logWrap">
          <v-text-field
            filled
            rounded
            dense
            append-icon="person_pin"
            name="username"
            label="Nombre de usuario"
            type="text"
            v-model="username"
            disabled
            :rules="[rules.required]"
            persistent-hint
          />
          <v-text-field
            filled
            rounded
            dense
            append-icon="face"
            name="nombre"
            label="Nombre"
            type="text"
            v-model="nombre"
            :rules="[rules.required]"
            persistent-hint
          />
          <v-text-field
            filled
            rounded
            dense
            append-icon="person"
            name="email"
            label="Correo electrónico"
            type="text"
            v-model="email"
            :rules="[rules.required, rules.validateEmail]"
            persistent-hint
          />
          <!-- <v-text-field
            filled
            rounded
            dense
            name="role"
            label="Rol"
            type="text"
            v-model="role"
            disabled
            persistent-hint
          /> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="confirm('confirmar')"
            class="white--text logWrap"
            color="#004283"
          >
            Confirmar
          </v-btn>
          <v-btn
            @click="confirm('cerrar')"
            class="white--text logWrap"
            color="#004283"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </transition>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: {
        required: value => !!value || "Campo requerido.",
        validateEmail: value =>
          value.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) != null || "Campo 'Correo Electrónico' inválido"
      },
      email: "",
      nombre: "",
      username: "",
      role: '',
      user: this.$store.state.auth.user
    };
  },
  methods: {
    confirm(action) {
      if (action == "confirmar") {
        if (this.nombre == undefined || /^\s*$/.test(this.nombre)) {
          this.$emit("closePD", "Campo 'Nombre' vacío");
        } else if (this.username == undefined || /^\s*$/.test(this.username)) {
          this.$emit("closePD", "Campo 'Username' vacío");
        } else if (this.email == undefined || this.email.match(/^\s*$/)) {
          this.$emit("closePD", "Campo 'Correo Electrónico' vacío");
        } else if (
          this.email != undefined &&
          this.email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) == null
        ) {
          this.$emit("closePD", "Campo 'Correo Electrónico' incorrecto");
        } else {
          this.$emit("closePD", action, {
            id: this.user.id,
            nombre: this.nombre,
            username: this.username,
            email: this.email,
            // accessToken: this.user.accessToken,
            // expiryDate: this.user.expiryDate,
            // id_role: this.user.id_role,
            // password: this.user.password
          });
        }
      } else {
        this.$emit("closePD", action);
      }
    },
    async setData() {
      this.email = this.user.email;
      this.nombre = this.user.nombre;
      this.username = this.user.username;
      // this.id_role = this.user.id_role;
      // this.role = this.user.role.name
    },
  },
  mounted() {
    this.setData();
  }
};
</script>

<style scoped>
.logWrap {
  border-radius: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalPersonalData.vue